var ehh = require('src/creative/core-page/at-a-glance-carousel/at-a-glance-carousel-event-handlers-helpers');
var filterEvents = require('src/creative/core-page/at-a-glance-carousel/at-a-glance-carousel-filter-events');
var aagcData = require('src/creative/core-page/at-a-glance-carousel/at-a-glance-carousel-data');
var carouselEvents = require('src/interlock/ui/owl-carousel/carousel-events');
var aagCarouselContent = require('src/creative/core-page/at-a-glance-carousel/at-a-glance-carousel-content');
var EventHandlers = function() {
    var aagc, cats, cOwl, captionText;
    var indexesCalculated = false;
    var firstPrepend = false;
    var OFFSET = 5;
    var carouselIndexes = { currentIndex: 0, x: 0, y: 0 };
    var currentFilterCategory = aagcData.CATEGORY_HOME;
    var web503 = ($('.image-type-selector').data('abtest') === 'web-503');

    aagc = document.querySelector('.at-a-glance-carousel-wrapper');
    if (aagc) {
        cats = aagc.querySelector('.categories');
        cOwl = aagc.querySelector('.owl-carousel');
        captionText = aagc.querySelector('.caption-text');
    }

    // Repopulates Image Carousel with given Image Category, IE: exterior, dashboard, etc.
    var updateCarouselWith = function(imageType) {
        var options = {
            imageType: imageType
        };
        aagcData.getSomeData(aagcData.getRestUrl(options), function(data) {
            if (data && data.photos) {
                aagCarouselContent.clear();

                // Get Category Photos
                pushPhotos(data, aagcData.getIndexOfCategory(imageType), false);

            }
        }).then(function() {
            var index = aagcData.getIndexOfCategory(imageType) - OFFSET;
            if(index < 0) {
                index = OFFSET;
            }
            // Prepend (like init, so if user goes back)
            var options = { 'index': index };

            aagcData.getSomeData(aagcData.getRestUrl(options), function(data2) {
                pushPhotos(data2, options.index, true);
            }).then(function() {
                // Reposition to current slide, because prepend/refresh repositions carousel to 0 slot.
                carouselEvents.changeSlide($(cOwl), OFFSET, 85);
                _updateIndexes(null, aagcData.getIndexOfCategory(imageType) + OFFSET - 1, null);
            });
        });
    };

    var applyHomeCategory = function() {
        // move to the initial slide
        if(currentFilterCategory != aagcData.CATEGORY_HOME) {
            aagCarouselContent.restore(aagcData.CATEGORY_HOME);
        } else {
            carouselEvents.changeSlide($(cOwl), OFFSET, 85);
        }
    };

    var changeCategory = function(categoryId) {
        (categoryId === aagcData.CATEGORY_HOME || categoryId === 'all' ) ? applyHomeCategory() : updateCarouselWith(categoryId);
        filterEvents.fireChangeContent(categoryId);
        currentFilterCategory = categoryId;
        aagCarouselContent.isSmall() && filterEvents.toggleFilter(false);
    };

    var pushPhotos = function(data, startIndex, prepend) {
        var indexPlus = startIndex;
        var prependIndex = startIndex + OFFSET;
        var photoCount = 0;
        for (var cat in data.photos) {
            if (data.photos[cat].length) {
                var photosArr = data.photos[cat];
                if (prepend) {
                    photosArr = photosArr.reverse();
                }
                photosArr.forEach(function(el) {
                    var slide;
                    photoCount++;
                    if (prepend) {
                        slide = ehh.createSlide(el, true, --prependIndex);
                        carouselEvents.addSlide($(cOwl), slide, 0);
                    } else {
                        slide = ehh.createSlide(el, true, ++indexPlus);
                        carouselEvents.addSlide($(cOwl), slide);
                    }
                });
            }
        }

        if (prepend) {
            postPrepend(startIndex, photoCount);
        } else {
            _updateIndexes(null, carouselIndexes.x + OFFSET, null);
        }
        // Refreshing the carousl, rebuilds Owl, and settimeout helps removes carousel Jank from refresh.
        // DO NOT REMOVE unless you know what you're doing - Jason.
        setTimeout(function() {
            carouselEvents.refresh($(cOwl));
        }, 800);
    };

    var postPrepend = function(startIndex, photoCount) {
        _updateIndexes(null, null, startIndex);
        // Loser Logic to handle indexes in initial prepend.
        if(!photoCount) {
            photoCount = 0;
        }
        if (!firstPrepend) {
            firstPrepend = true;
            var offset = photoCount < OFFSET ? photoCount : OFFSET;
            var iil = parseInt(aagc.getAttribute('data-initial-image-length'), 10) - 1;
            _updateIndexes(null, iil || offset, null);
            carouselEvents.changeSlide($(cOwl), offset, 100);
        }
    };

    var _updateIndexes = function(idx, x, y) {
        if (typeof idx == 'number') {
            carouselIndexes.currentIndex = idx;
        }
        if (typeof x == 'number') {
            carouselIndexes.x = x;
        }
        if (typeof y == 'number') {
            carouselIndexes.y = y;
        }
    };

    return {
        getIndexes: function() {
            return carouselIndexes;
        },
        updateIndexes: _updateIndexes,
        fetchIndexes: function(cb) {
            if (!indexesCalculated && cats && cats.innerHTML.length < 1) {
                var options = {
                    minimal: true
                };
                indexesCalculated = true;
                aagcData.getSomeData(aagcData.getRestUrl(options), function(data) {
                    if (data) {
                        aagcData.calculateIndexes(data);
                        ehh.populateTypeFilter(aagcData, cats, data.categoryCounts);
                        if (cb) {
                            cb(data);
                        }
                    }
                });
            }
        },

        populateAltBox: function(curIndex) {
            if (curIndex) {
                var el = aagc.querySelector('.item[data-index="' + curIndex + '"] .carousel-image');
                var caption = el.getAttribute('data-alt');
                captionText.innerHTML = caption;
            }
        },
        appendPhotos: function(getIndex, prepend, atIndex) {
            if(getIndex > -1) {
                var options = { index: getIndex };
                aagcData.getSomeData(aagcData.getRestUrl(options), function(data) {
                    if (data && data.photos) {
                        pushPhotos(data, options.index, prepend || false, atIndex);
                    }
                });
            }
        },
        handleSubmodelChange: function(e, data) {
            if (data.submodelDisplayName) {
                aagc.querySelector('.submodel-label').innerHTML = data.submodelDisplayName;
            }
        },
        handleCategoryChange: function(e) {
            var tar = e.target;
            e.preventDefault();
            if(web503){
                var aTag = $(tar).closest('a');
                captionText.innerHTML = '';
                if(aTag.length > 0 && aTag[0].nodeName === 'A'){
                    changeCategory(aTag[0].getAttribute('data-image-type'));
                }
            } else if (tar && tar.nodeName === 'A') {
                captionText.innerHTML = '';
                changeCategory(tar.getAttribute('data-image-type'));
            }
        }
    };

};
module.exports = new EventHandlers();



//////////////////
// WEBPACK FOOTER
// ./src/creative/core-page/at-a-glance-carousel/at-a-glance-carousel-event-handlers.js
// module id = 170
// module chunks = 0 1 27